const currencies = [
  {
    code: "RUR",
    symbol: "₽",
    title_rus: "Руб.",
    title_eng: "RUB"
  },
  {
    code: "USD",
    symbol: "$",
    title_rus: "Дол.",
    title_eng: "USD"
  },
  {
    code: "EUR",
    symbol: "€",
    title_rus: "Евро",
    title_eng: "EUR"
  },
  {
    code: "CNY",
    symbol: "¥",
    title_rus: "Юань",
    title_eng: "CNY"
  }
];

export default currencies;
